module.exports = __webpack_public_path__ + "assets/lever.996fa7e0.svg";